import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b699ee26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-end mt-4" }
const _hoisted_2 = { class: "container-user-list-table py-4" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "user-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Email", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  colspan: "4",
  class: "text-center py-8"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center py-8"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "Error Found")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "text-center py-8"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "No Data")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VButton = _resolveComponent("VButton")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VButton, {
        message: 'Export',
        radius: '20px',
        bgBorder: '1px solid #dadbe6',
        width: '10rem',
        isDisable: _ctx.isNoCampaign,
        src: require('@/assets/svgs/icons/csv.svg'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DoExportExcel()))
      }, null, 8, ["isDisable", "src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("th", _hoisted_6, [
                _createTextVNode(" Register Date "),
                _createElementVNode("img", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort())),
                  src: _ctx.$data[_ctx.sortIcon],
                  alt: "SVG Image"
                }, null, 8, _hoisted_7)
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.isLoadingUserList && !_ctx.isErrorLoadingUserList)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", _hoisted_10, [
                    _createVNode(_component_v_progress_circular, {
                      color: "#3B3C66",
                      indeterminate: "",
                      width: 3,
                      size: 25
                    })
                  ])
                ]))
              : (_ctx.isErrorLoadingUserList && !_ctx.isLoadingUserList)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _hoisted_13))
                : (!_ctx.userList || _ctx.userList.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.userList, (user, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.id,
                        class: "data-row"
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.firstIndexInPage + index + 1), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.formatDate(user.registerDate)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("p", {
                            class: "text-ellipsis-max-w-300",
                            title: user.username
                          }, _toDisplayString(user.username), 9, _hoisted_19)
                        ])
                      ]))
                    }), 128))
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        class: "pagination",
        justifyContent: "flex-end",
        data: _ctx.pagination,
        totalPage: _ctx.paginationUserList.totalPages,
        onPage: _ctx.handlePageChange,
        onPerPageEvent: _ctx.handleSelectPageNumber,
        onLength: _ctx.handlePageLengthChange
      }, null, 8, ["data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
    ])
  ], 64))
}